import { VARIANT_OF_REFUND_ALL } from '~/consts/refund';

import { Refund } from '../NewModal';

export function getRefundableMerchantFee(refund: Refund) {
  const isFullRefund = refund.variant_of_refund === VARIANT_OF_REFUND_ALL;
  return isFullRefund ? refund.merchant_fee_amount || 0 : 0;
}
